import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { ActAddress, CivilityType } from '../../data/interfaces.ts';
import { actApi } from '../apis/act.api.ts';

const actAddressInitialState: Partial<ActAddress> = {
  civility: CivilityType.MALE,
  firstName: '',
  lastName: '',
  country: 'France',
  address: '',
  postalCode: '',
  city: '',
  email: '',
  validateEmail: '',
  phone: ''
}

export const actAddressSlice = createSlice({
  name: 'actAddress',
  initialState: actAddressInitialState,
  reducers: {
    setActAddress(state, action: PayloadAction<ActAddress>) {
      return action.payload
    },
    resetActAddress(state) {
      return actAddressInitialState
    }
  },
  extraReducers(builder) {
    builder.addMatcher(
      actApi.endpoints.addAct.matchFulfilled,
      (state, action) => {
        return actAddressInitialState
      }
    );
  }
});

export const actAddressReducer = persistReducer({
  key: 'rtk:actAddress',
  storage,
  whitelist: ['civility', 'firstName', 'lastName', 'country', 'address', 'postalCode', 'city', 'email', 'validateEmail', 'phone']
}, actAddressSlice.reducer);

export const { setActAddress, resetActAddress } = actAddressSlice.actions;
